import React from 'react';

//@ts-ignore
import '../../styles/star-rating.scss';
import { LinearProgress, Typography } from '@mui/joy';

function RatingDistributionComponent({ reviews, total }: any) {

    const distribution = reviews.map((list: any, index: number) =>
        <div className='row my-auto'>
            <div className="col-auto text-left">
                <span className="legend light-iron">{index + 1}</span>
            </div>
            <div className='col p-0 my-auto'>
                {list.length !== 0 &&
                    <LinearProgress determinate value={(list.length / total) * 100} />
                }
            </div>
            <div className='col-auto my-auto'>
                <Typography
                    color='neutral'
                    fontWeight={800}
                    sx={{
                        fontSize: 10
                    }}>
                    {list.length}
                    <Typography
                        color='neutral'
                        fontWeight={400}
                        sx={{
                            fontSize: 10
                        }}>
                        ({((list.length / total) * 100).toFixed(1)}%)
                    </Typography>
                </Typography>
            </div>
        </div>
    );

    return (
        <div>
            {distribution}
        </div>
    );
}

export default RatingDistributionComponent;